import Loadable from 'components/global/Loadable';
import CompanySnapshotRow from 'components/global/CompanySnapShotRow/CompanySnapshotRow';
import PublicRoomContainer from 'components/views/PublicRoom/_components/PublicRoomContainer';
import { $detail } from 'signals/global.signals';
import { formatMoneyNoDecimals } from 'utils/formatMoney';
import SimpleCard from 'components/global/SimpleCard';
import { DEBT_RAISE_TYPES } from 'constants/globalConstants';

const PublicRoomTerms = () => (
  <PublicRoomContainer>
    <SimpleCard>
      <Loadable signal={$detail}>
        <CompanySnapshotRow label="Type of Raise" value={$detail.value.typeOfRaise} />
        <CompanySnapshotRow label="Investment Stage" value={$detail.value.investmentStage} />
        <CompanySnapshotRow label="Deal Terms" value={$detail.value?.dealTerms} />
        {$detail.value.investmentStage !== 'Acquisition' && (
          <>
            <CompanySnapshotRow label="Current Raise Size" value={formatMoneyNoDecimals($detail.value.currentRaiseSize)} />
            <CompanySnapshotRow label="Committed To Date" value={formatMoneyNoDecimals($detail.value.amountCommitted)} />
            <CompanySnapshotRow label="Minimum Investment" value={$detail.value.minimumInvestment ? formatMoneyNoDecimals($detail.value.minimumInvestment) : 'Not specified'} />
            <CompanySnapshotRow label="Pre-Money Valuation" value={$detail.value.preMoneyValuation ? formatMoneyNoDecimals($detail.value.preMoneyValuation) : 'Not specified'} />
          </>
        )}
        {DEBT_RAISE_TYPES.includes($detail.value.typeOfRaise) && (
          <>
            <CompanySnapshotRow label="Cap" value={formatMoneyNoDecimals($detail.value.cap)} />
            <CompanySnapshotRow label="Discount Percent" value={$detail.value.discountPercent ? `${$detail.value.discountPercent}%` : 'None'} />
            <CompanySnapshotRow label="Interest Rate" value={$detail.value?.interestRate ? `${$detail.value?.interestRate}%` : 'None'} />
          </>
        )}
        {$detail.value.investmentStage !== 'Acquisition' && (
          <CompanySnapshotRow label="Uses of Capital" value={$detail.value?.usesOfCapital} />
        )}
      </Loadable>
    </SimpleCard>
  </PublicRoomContainer>
);

export default PublicRoomTerms;
